import { isGlovvKr } from "constants/domains/domains";
import { useEffect } from "react";

/**
 * Google Tag Manager
 * 
 * Put this component in the top of body tag
 * 
 * @returns 
 */
const GoogleTagManager = () => {
  // Create header script
  useEffect(() => {
    if (!isGlovvKr())
      return;

    // Create script element
    const script = document.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-KCPHG5R5');
    `;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  if (!isGlovvKr())
    return null;

  return (
    <>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-KCPHG5R5" 
          height="0" width="0" 
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  );
};

export default GoogleTagManager